import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_Snomed = {
    _v1: {
        scrapeBySearchTerm: { method: HttpMethod.GET, path: '/v1/snomed/scrape-by-search-term', timeout: 2 * Minute },
    }
};
//# sourceMappingURL=api-def.js.map